import React, { useState } from "react";

//
import { Col, Row, Card } from "react-bootstrap";

//
import LearnMore from "../../components/general/LearnMore";
import PageHeader from "../../components/general/PageHeader";
import CostChart from "../../components/dollar-cost/CostChart";
import DCAQuestion from "../../components/dollar-cost/DCAQuestion";
import FilterDropdown from "../../components/general/FilterDropdown";
import FilterSettingForm from "../../components/dollar-cost/FilterSettingForm";
import DollarCostStatistics from "../../components/dollar-cost/DollarCostStatistics";

//
import Bitcoin from "../../assets/img/bitcoin.png";
import Dollar_Cost from "../../assets/img/dollar-cost.png";
import DollarCostQuestion from "../../assets/img/dollar-cost-question.png";

function DollarCost() {
  const [activeFilter, setActiveFilter] = useState({});
  const [chartData, setChartData] = useState({
    labels: [],
    investment: [],
    principal: [],
  });
  const [convertedData, setConvertedData] = useState({
    value: 0,
    invest: 0,
    percent: 0,
  });

  const updateChartData = (data) => {
    let chart = { ...chartData };
    chart.principal = data.principal;
    chart.investment = data.investment;
    chart.labels = data.date;

    setChartData(chart);

    let datas = { ...convertedData };
    datas.value = data.investment[data.investment.length - 1];

    datas.invest = data.principal[data.principal.length - 1];

    if (datas.invest > datas.value) {
      datas.percent = datas.value / datas.invest;
    } else {
      datas.percent = (datas.value * 100) / datas.invest;
    }

    setConvertedData(datas);
  };

  // const filters = [
  //   {
  //     name: "one",
  //     value: "one",
  //   },
  //   {
  //     name: "two",
  //     value: "two",
  //   },
  //   {
  //     name: "three",
  //     value: "three",
  //   },
  // ];

  return (
    <div id="dollar-cost">
      <PageHeader
        title="Dollar Cost Averaging Bitcoin"
        subject="Crypto details overview and analytics"
      />

      <Card className="gutter-b">
        <Row>
          <Col lg={3}>
            <FilterSettingForm updateChartData={updateChartData} />
          </Col>

          <Col lg={9} className="chart-box">
            <Card>
              <Card.Body className="pb-md-0">
                <Row className="h-100">
                  <Col
                    md={8}
                    className="d-flex flex-column justify-content-between"
                  >
                    <header>
                      <p className="fw-bolder text-black">
                        Portofolio Value Over Time
                      </p>

                      {/* <FilterDropdown
                        filters={filters}
                        activeFilter={activeFilter}
                        action={(item) => setActiveFilter(item)}
                        full
                        fit
                      /> */}
                    </header>
                    <CostChart chartData={chartData} />
                  </Col>

                  <Col md={4}>
                    <DollarCostStatistics data={convertedData} />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card>

      <Row className="justify-content-center">
        <Col md={6} lg={4} className="gutter-b">
          <LearnMore
            title="How to use Bitcoin Dollar Cost Averaging tool?"
            subject="DCA tool investment strategy where a person invests a set amount of money over given time intervals."
            src={Bitcoin}
          />
        </Col>
        <Col md={6} lg={4} className="gutter-b">
          <LearnMore
            title="What is Dollar Cost Averaging Bitcoin?"
            subject="Bitcoin dollar cost averaging consists in investing a fixed amount of USD, into BTC, on regular time intervals."
            src={DollarCostQuestion}
            modal={<DCAQuestion />}
          />
        </Col>
        <Col md={6} lg={4} className="gutter-b">
          <LearnMore
            title="Pros and Cons of Dollar Cost Averaging Bitcoin"
            subject="Dollar cost averaging is a powerful strategy for investors looking to get long-term exposure to Bitcoin. "
            src={Dollar_Cost}
          />
        </Col>
      </Row>
    </div>
  );
}

export default DollarCost;
